import { data } from "autoprefixer";
import axios from "axios";
import Cookies from "universal-cookie";

function getToken() {
    const cookies = new Cookies();
    return cookies.get("token");
}

export function getSubjects(params) {
    const url = process.env.REACT_APP_API_BASE_URL + '/subjects';
    return axios.get(url, {
        params,
        headers: {
            authorization: `Bearer ${getToken()}`
        }
    });
}

export function upsertSubject(data) {
    const url = process.env.REACT_APP_API_BASE_URL + '/subjects/upsert';
    return axios.post(url, data, {
        headers: {
            authorization: `Bearer ${getToken()}`
        }
    });
}

export function deleteSubject(id) {
    const url = process.env.REACT_APP_API_BASE_URL + `/subjects/${id}`;
    return axios.delete(url, {
        headers: {
            authorization: `Bearer ${getToken()}`
        }
    });
}

export function generatePublicFormLink(data) {
    const url = process.env.REACT_APP_API_BASE_URL + '/subjects/generate-public-link';
    return axios.post(url, data, {
        headers: {
            authorization: `Bearer ${getToken()}`
        }
    });
}

export function disablePublicFormLink(data) {
    const url = process.env.REACT_APP_API_BASE_URL + '/subjects/disable-public-link';
    return axios.post(url, data, {
        headers: {
            authorization: `Bearer ${getToken()}`
        }
    });
}

export function verifyPublicFormPassword(token, password) {
    const url = process.env.REACT_APP_API_BASE_URL + '/public/subjects/form/' + token + '/check-password';
    return axios.post(url, {
        token,
        password
    });
}

export function getPublicForm(token) {
    const url = process.env.REACT_APP_API_BASE_URL + `/public/subjects/form/${token}`;
    return axios.get(url);
}

export function submitPublicForm(token, data) {
    const url = process.env.REACT_APP_API_BASE_URL + `/public/subjects/form/${token}`;
    return axios.post(url, data);
}

export function checkPublicFormAccess(token) {
    const url = process.env.REACT_APP_API_BASE_URL + `/public/subjects/form/${token}/access`;
    return axios.get(url);
}
